import { QUERIES, matchMediaDirectiveName } from './match-media.utils';
import { $applySmartEventHandler } from '../../../../helpers/digest/digest';

directive.prefixName = 'updClassMatchMedia';

/**
 * Wrapper around `ng-class`, adding/removing CSS classes to the given element
 * based on media queries.
 */
export function directive(query) {
  const directiveName = matchMediaDirectiveName(directive.prefixName, query);

  return ($window, ngClassDirective) => {
    'ngInject';
    // Technique to re-use `ngClass` implementation:
    // https://stackoverflow.com/a/24065378/89594
    const ngClass = ngClassDirective[0];

    return {
      link: function ($scope, $element, $attr) {
        const originalNgClass = $attr.ngClass;
        const mediaNgClass = $attr[directiveName];
        const mediaQueryList = $window.matchMedia(QUERIES[query]);
        const handleMediaQueryListChange = $applySmartEventHandler(
          $scope,
          (event) => toggle(event.matches)
        );

        let value = [originalNgClass];

        // ngClass expects attr['ngClass'] to be an expression to pass into $parse
        const classExpression = (scope) =>
          value ? value.map((exp) => scope.$eval(exp)) : undefined;
        classExpression.charAt = () => undefined;
        $attr.ngClass = classExpression;

        ngClass.link.apply(ngClass, arguments);

        // Wait until end of digest to apply the current (if any) media query's
        // classes, else we'd interfere with other instances of this directive
        // on the same element.
        $scope.$evalAsync(() => toggle(mediaQueryList.matches));

        mediaQueryList.addListener(handleMediaQueryListChange);
        $scope.$on('$destroy', () =>
          mediaQueryList.removeListener(handleMediaQueryListChange)
        );

        function toggle(bool) {
          // Add/remove the given classes if the media query matches/does not match.
          value = [originalNgClass].concat(bool ? mediaNgClass : []);
        }
      },
    };
  };
}
